import { useUser } from '@clerk/react';

/**
 * Allowed staff email domains — must match the backend's
 * `Renturio:StaffEmailDomains` config.
 */
const STAFF_EMAIL_DOMAINS = ['exio.no', '7peakssoftware.com'];

/**
 * Returns true if the current Clerk user's primary email matches one of the
 * configured staff email domains. Used to gate the
 * `/onboarding/portfolio/invite` admin page.
 *
 * While Clerk is still loading, returns `false` to fail-safe.
 */
export function useIsExioStaff(): { isLoaded: boolean; isStaff: boolean } {
  const { isLoaded, user } = useUser();

  if (!isLoaded) {
    return { isLoaded: false, isStaff: false };
  }

  const email = user?.primaryEmailAddress?.emailAddress?.toLowerCase() ?? '';
  const isStaff = STAFF_EMAIL_DOMAINS.some((d) => email.endsWith('@' + d));

  return { isLoaded: true, isStaff };
}
